import React, { useEffect, useState, useRef } from 'react';

const TAGLINE = 'Your Health, Our Priority';

export default function SplashScreen({ onDone }) {
  const [logoVisible, setLogoVisible] = useState(false);
  const [typedText,   setTypedText]   = useState('');
  const [fadeOut,     setFadeOut]     = useState(false);
  const typerRef = useRef(null);

  useEffect(() => {
    // Logo fades in immediately
    const t0 = setTimeout(() => setLogoVisible(true), 100);

    // Typing animation starts after logo appears
    let i = 0;
    const t1 = setTimeout(() => {
      typerRef.current = setInterval(() => {
        i += 1;
        setTypedText(TAGLINE.slice(0, i));
        if (i >= TAGLINE.length) {
          clearInterval(typerRef.current);
        }
      }, 55);
    }, 700);

    // Start fade-out
    const t2 = setTimeout(() => setFadeOut(true), 2600);
    // Done
    const t3 = setTimeout(() => onDone?.(), 3000);

    return () => {
      clearTimeout(t0); clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
      if (typerRef.current) clearInterval(typerRef.current);
    };
  }, [onDone]);

  return (
    <div style={{
      position:        'fixed',
      inset:           0,
      zIndex:          99999,
      backgroundColor: '#ffffff',
      display:         'flex',
      flexDirection:   'column',
      alignItems:      'center',
      justifyContent:  'center',
      opacity:         fadeOut ? 0 : 1,
      transition:      'opacity 0.45s ease-out',
    }}>

      {/* Logo image — no box, no shadow, pure white bg */}
      <img
        src="/logo192.png"
        alt="Faristaa"
        style={{
          width:      120,
          height:     120,
          objectFit:  'contain',
          opacity:    logoVisible ? 1 : 0,
          transform:  logoVisible ? 'scale(1)' : 'scale(0.8)',
          transition: 'opacity 0.5s ease, transform 0.5s cubic-bezier(0.34,1.56,0.64,1)',
        }}
        onError={e => {
          e.target.style.display = 'none';
          document.getElementById('splash-fallback-text').style.display = 'block';
        }}
      />
      {/* Fallback text logo */}
      <span id="splash-fallback-text" style={{
        display:     'none',
        fontSize:    40,
        fontWeight:  900,
        color:       '#0D9488',
        fontFamily:  'system-ui, -apple-system, sans-serif',
        letterSpacing: '-1.5px',
        opacity:     logoVisible ? 1 : 0,
        transition:  'opacity 0.5s ease',
      }}>
        Faristaa
      </span>

      {/* Typing tagline — teal color */}
      <p style={{
        marginTop:   20,
        fontSize:    14,
        fontWeight:  500,
        color:       '#0D9488',
        fontFamily:  'system-ui, -apple-system, sans-serif',
        letterSpacing: '0.3px',
        minHeight:   20,
      }}>
        {typedText}
        {typedText.length < TAGLINE.length && (
          <span style={{
            display:         'inline-block',
            width:           2,
            height:          14,
            backgroundColor: '#0D9488',
            marginLeft:      1,
            animation:       'splashCursor 0.7s step-end infinite',
          }} />
        )}
      </p>

      {/* Loading dots at bottom */}
      <div style={{
        position:   'absolute',
        bottom:     52,
        display:    'flex',
        gap:        7,
        alignItems: 'center',
        opacity:    logoVisible ? 1 : 0,
        transition: 'opacity 0.5s ease 0.4s',
      }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width:           5,
            height:          5,
            borderRadius:    '50%',
            backgroundColor: '#0D9488',
            animation:       `splashDot 1.2s ease-in-out ${i * 0.2}s infinite`,
          }} />
        ))}
      </div>

      <style>{`
        @keyframes splashDot {
          0%, 80%, 100% { transform: scale(0.55); opacity: 0.2; }
          40%            { transform: scale(1.1);  opacity: 1;   }
        }
        @keyframes splashCursor {
          0%, 100% { opacity: 1; }
          50%      { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
